import api from './api-config';

export const getMerchantsList = async () => {
    try {
        const response = await api.get('/data-silo/merchants');
        return response.data;
    } catch (error) {
        console.error('Error fetching merchants list:', error);
        throw error;
    }
};

export const getTransactionTypesList = async () => {
    try {
        const response = await api.get('/data-silo/transaction-types');
        return response.data;
    } catch (error) {
        console.error('Error fetching transaction types list:', error);
        throw error;
    }
};

